import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './accountManagerView.html';
import logger from '../../../shared/logger';
import UtilsService from '../../../services/utilsService';

export class AccountManagerComponent {
    /* @ngInject */
    constructor(
        AuthService,
        RecruiterService,
        EmployerService,
        $cookies,
        $state,
        $translate,
        RouteService,
        WebAppRouteService,
    ) {
        const accountManagerCtrl = this;
        accountManagerCtrl.init = function () {
        };

        UtilsService.cookiesOverride($cookies);

        const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
        const userData = UtilsService.parseJSON($cookies.get('userData'));

        if (userData?.roles.indexOf('AM') < 0) {
            window.location.hash = '#/default';
            return;
        }

        accountManagerCtrl.toggleMenu = function () {
            $('.background')
                .toggle();
            $('.navbar-nav-menu')
                .toggle();
            accountManagerCtrl.showMenu = !accountManagerCtrl.showMenu;
        };

        accountManagerCtrl.closeMenu = function () {
            if (accountManagerCtrl.showMenu) {
                accountManagerCtrl.toggleMenu();
            }
        };

        accountManagerCtrl.userPicture = RouteService.getUserData('picture');

        if (userPrefs?.entityId) {
            accountManagerCtrl.recruiterUser = true;
            accountManagerCtrl.recruiterId = userPrefs.entityId;
        }

        EmployerService.getAllEmployersForMenu()
            .then(({ result: employers }) => {
                accountManagerCtrl.employers = _.orderBy(employers, ['settings.isResellerPartner', 'name'], ['desc', 'asc']);
            })
            .catch((err) => logger.error(err));

        accountManagerCtrl.logout = function () {
            AuthService.logout();
        };

        accountManagerCtrl.init();

        accountManagerCtrl.goPositionsPage = (employerId) => {
            WebAppRouteService.goPositionsPage({
                employerId,
            });
        };
    }
}

export const AccountManagerComponentConfiguration = {
    template,
    controller: AccountManagerComponent,
    controllerAs: 'accountManagerCtrl',
};

angular
    .module('TALENYA-FE')
    .component('accountManagerComponent', AccountManagerComponentConfiguration);
